import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Location from "./location";
import ProfileImage from "./profile-image";

const Sidebar = ({ players }) => {
  const images = useStaticQuery(graphql`
    query {
      michael: file(base: { eq: "michael.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 120, height: 120, layout: FIXED)
        }
      }
      masa: file(base: { eq: "masa.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 120, height: 120, layout: FIXED)
        }
      }
    }
  `);

  return (
    <aside className="w-full lg:w-1/3 lg:border-r border-line lg:px-6 xl:px-12 mb-6">
      <h1 className="font-header text-center font-black text-front text-3xl leading-none break-words mb-6">
        Score 100 Points to Win
      </h1>
      <div className="flex flex-col h-full justify-between">
        <div className="text-center">
          <p className="font-header font-black text-front text-xl leading-none mb-2">
            {players.player1.name}
          </p>
          <ProfileImage
            image={images[players.player1.image]}
            name={players.player1.name}
          />
          <br />
          <br />
          <p className="font-header font-black text-front text-xl leading-none mb-2">
            VS
          </p>
          <br />
          <p className="font-header font-black text-front text-xl leading-none mb-2">
            {players.player2.name}
          </p>
          <ProfileImage
            image={images[players.player2.image]}
            name={players.player2.name}
          />
          <br />
          <Location />
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
